import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchPracticeSummary } from '../../store/slices/practiceSlice';
import PatientManagement from '../PracticeManagement/PatientManagement/PatientManagement';
import LoadingSpinner from '../../components/Common/LoadingSpinner/LoadingSpinner';
import './CaregiverDashboard.css';
import { getPracticeBillingPeriod } from '../../utils/billingPeriodUtils';

const CaregiverDashboard = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { currentPractice, isLoading } = useSelector((state) => state.practice ?? {});

    // State for practice ID - derived from user
    const practiceId = user?.practice_id;

    useEffect(() => {
        if (practiceId) {
            dispatch(fetchPracticeSummary(practiceId));
        }
    }, [dispatch, practiceId]);

    if (isLoading && !currentPractice) {
        return <LoadingSpinner />;
    }

    // Format billing period dates
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
        });
    };

    const { start, end } = getPracticeBillingPeriod(currentPractice);
    const billingStart = start ? formatDate(start) : '';
    const billingEnd = end ? formatDate(end) : '';
    const billingPeriod = billingStart && billingEnd ? `${billingStart} - ${billingEnd}` : 'N/A';

    return (
        <div className="caregiver-dashboard-feature-container">
            {/* Header Section */}
            <div className="caregiver-dashboard-feature-header">
                <h2 className="caregiver-dashboard-feature-practice-name">
                    {currentPractice?.practice_name || 'Practice Name'}
                </h2>
                <div className="caregiver-dashboard-feature-billing-info">
                    Billing Period: {billingPeriod}
                </div>
            </div>

            {/* Main Content - Patient Management */}
            <div className="caregiver-dashboard-feature-content">
                {practiceId ? (
                    // Reusing PatientManagement component but assuming it handles its own layout
                    // We might need to pass props to adjust its display if needed, 
                    // but currently it seems self-contained with stats cards.
                    <div className="p-3">
                        <PatientManagement practiceId={practiceId} isDashboardView={true} />
                    </div>
                ) : (
                    <div className="alert alert-warning m-4">
                        Practice information not found. Please contact support.
                    </div>
                )}
            </div>
        </div>
    );
};

export default CaregiverDashboard;
